import React from "react";
import { isEmpty } from "lodash";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import PlaneShape03 from "@/components/shapes/PlaneShape03";
import CtaShape02 from "@/components/shapes/CtaShape02";
// types
import TResource from "@/cms/types/TResource";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ELayoutType from "@/cms/enums/ELayoutType";
// types
import { TMainPageLayoutV2 } from "../type";
import { outerNameDescriptionLanguageVersion, pageNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import clsx from "clsx";


type TRender = {
    languageVersion: TLanguageVersionList|TLanguageVersionDetail;
    resources?: TResource[];
    resourceType: EResourceType;

    childs?:TClientMainPageItemList[];
    languageVersionSelector:any
    _layoutType?:ELayoutType;
}

const RenderItemsLeft = ( props:TRender ) => {
    return props.childs?.map((item,index) => {
        const languageVersionItem:TLanguageVersionList = props.languageVersionSelector(item.languageVersions);
        return (
            <div
                className="value-icon-items"
                data-aos-duration="800"
                data-aos="fade-up"
                data-aos-delay={`${300+(index*200)}`}
            >
                <div className="icon">
                    <RMDRImage
                        resources={item.resources}
                        resourceType={EResourceType.ICON}
                        alt={languageVersionItem.name}
                        title={languageVersionItem.name}
                    />
                </div>
                <div className="content">
                    <h5 className="tw-line-clamp-1" title={languageVersionItem.name||""}>{languageVersionItem.name}</h5>
                    <RMDRComponentSanitizer languageVersion={languageVersionItem} variant="p" valueExpr="value" className="tw-h-[84px] tw-line-clamp-3" removeTag />
                </div>
            </div>
        )
    })
}

const RenderItemsRight = ( props:TRender ) => {
    return props.childs?.map((item,index) => {
        const languageVersionItem:TLanguageVersionList = props.languageVersionSelector(item.languageVersions);
        return (
            <div
                className="value-icon-items"
                data-aos-duration="800"
                data-aos="fade-up"
                data-aos-delay={`${300+(index*200)}`}
            >
                <div className="content">
                    <h5 className="tw-line-clamp-1" title={languageVersionItem.name||""}>{languageVersionItem.name}</h5>
                    <RMDRComponentSanitizer languageVersion={languageVersionItem} variant="p" valueExpr="value" className="tw-h-[84px] tw-line-clamp-3" removeTag />
                </div>
                <div className="icon">
                    <RMDRImage
                        resources={item.resources}
                        resourceType={EResourceType.ICON}
                        alt={languageVersionItem.name}
                        title={languageVersionItem.name}
                    />
                </div>
            </div>
        )
    })
}

const Render = ( props:TRender ) => {

    const allItemCount = props.childs ? props.childs.length : 0; 
    const sideItemCount = allItemCount > 0 ? Math.ceil(allItemCount/2) : 0;

    return (
        <section className={clsx("section fix", {"section-padding":props._layoutType}, {"section-padding-2":!props._layoutType})}>
            <PlaneShape03 className="float-bob-y" />
            <div className="container">
                <div className="row">

                    <div className="col-xl-4 col-lg-6">
                        <div className="feature-value-items">
                            <RenderItemsLeft {...props} childs={props.childs?.slice(0,sideItemCount)} />
                        </div>
                    </div>

                    <div
                        className="col-xl-4 col-lg-6 "
                        data-aos-duration="800"
                        data-aos="fade-up"
                        data-aos-delay="400"
                    >
                        <div className="feature-value-items">
                            <div className="feature-value-image-s2">
                                <RMDRImage
                                    resources={props.resources}
                                    resourceType={props.resourceType}
                                    alt={props.languageVersion.name}
                                    title={props.languageVersion.name}
                                />
                                {/* <CtaShape02 /> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-lg-6">
                        <div className="feature-value-items">
                            <RenderItemsRight {...props} childs={props.childs?.slice(sideItemCount,allItemCount)} />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

const RenderDetails = ( props:TMainPageLayoutV2 ) => {

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.params["contentDetails"].languageVersions);
    const childs = props.templates?.filter((item) => item.parentId === props.template?.id)

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion} 
        resources={props.template?.resources} 
        resourceType={EResourceType.OUTER_IMAGE} 
        languageVersionSelector={outerNameDescriptionLanguageVersion}
        childs={childs}
        _layoutType={props._layoutType}
    />

}

const RenderTemplate = ( props:TMainPageLayoutV2 ) => {

    if ( !props.template || isEmpty(props.template) ) return null;

    const languageVersion = pageNameDescriptionLanguageVersion(props.template.languageVersions);
    const childs = props.templates?.filter((item) => item.parentId === props.template?.id)

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion} 
        resources={props.template.resources} 
        resourceType={EResourceType.OUTER_IMAGE} 
        languageVersionSelector={outerNameDescriptionLanguageVersion}
        childs={childs}
        _layoutType={props._layoutType}
    />

}

const MNPG053 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG053.rendered", props); 

    if ( !props.template || isEmpty(props.template) ) return null;

    if ( props._layoutType === ELayoutType.MAIN_PAGE ) {
        return <RenderTemplate {...props} />
    }
    else {
        return <RenderDetails {...props} />
    }
}

const Component = React.memo(MNPG053, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG053.memo", { prevProps, nextProps });
    return true;
});

export default Component;
